import EkomiRating from "../../../../../../packages/design-system/src/EkomiRating";
import * as React from 'react';
export default {
  EkomiRating,
  React
};